export default __webpack_public_path__ + "static/media/connect-light.310b15f3.png";